import { render, staticRenderFns } from "./receipt-cfg-form-dialog.vue?vue&type=template&id=a6ffbf22&scoped=true&"
import script from "./receipt-cfg-form-dialog.vue?vue&type=script&lang=js&"
export * from "./receipt-cfg-form-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ffbf22",
  null
  
)

export default component.exports